import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_GATEWAY_ROUTER_STRIPE_CREATE_CHARGE_CONFIG = defineFcm('gateway_router_stripe_create_charge_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				traffic_percentage: { type: 'number' },
				supported_currencies: { type: 'array', shape: { type: 'string' } },
				supported_payment_method_brands: { type: 'array', shape: { type: 'string' } },
				supported_payment_method_countries: { type: 'array', shape: { type: 'string' } },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform-payments',
		scope: 'payment-service',
		context: 'payment-service',
		description: `This configuration defines a country-specific rollout strategy for Stripe charge creation and applies routing rules based on currency, card brand, country, and user-level allowlists and blocklists.

			Currencies should be uppercase (e.g., 'EUR', 'GBP').

			Payment method brands should be lowercase (e.g., 'visa', 'mastercard').

			Countries should be uppercase (e.g., 'GB', 'AT').`,
		template: {
			traffic_percentage: 100,
			supported_currencies: ['EUR', 'GBP'],
			supported_payment_method_brands: ['visa', 'mastercard'],
			supported_payment_method_countries: ['GB', 'AT'],
		},
	});
